var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#64596B",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 15.625V29.375H19.375V15.625H16.875ZM15 15.625C15 14.5898 15.8398 13.75 16.875 13.75H19.375C20.4102 13.75 21.25 14.5898 21.25 15.625V29.375C21.25 30.4102 20.4102 31.25 19.375 31.25H16.875C15.8398 31.25 15 30.4102 15 29.375V15.625ZM25.625 15.625V29.375H28.125V15.625H25.625ZM23.75 15.625C23.75 14.5898 24.5898 13.75 25.625 13.75H28.125C29.1602 13.75 30 14.5898 30 15.625V29.375C30 30.4102 29.1602 31.25 28.125 31.25H25.625C24.5898 31.25 23.75 30.4102 23.75 29.375V15.625Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.1bdacfbcf5814f529b8dcf521e6208ea.svg";
export { ForwardRef as ReactComponent };